import React, { useState,useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { numberFormat, findArrayObject,findArrayObjectIndex,isEmpty, checkNumberOnly, numberWithCommas, replaceCommas, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
  getTripDetailsV3,
} from "../../../store/actions/tripActionCreator";
import {
  getSuggestionsTrips,
  addSinglePartyCompanyDetails,
  updateSinglePartyCompanyDetails
} from "../../../store/actions/partiesActionCreator";
import {
  getAllLocations
} from "../../../store/actions/homeActionCreator";
import {
  getAllDrivers,
} from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import RightSideBar from '../RightSideBar/RightSideBar';
import useMountEffect from '../../../mountEffect';
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Autocomplete,
  Switches
} from 'mui-rff';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import clsx from 'clsx';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import useStyles from '../css/addEditTrip'
import { Paper, InputAdornment,MenuItem, Divider } from '@material-ui/core';
import { trackDwebEvent } from '../../analytics';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import NotesIcon from '@material-ui/icons/Notes';
import InfoCard from '../Card/InfoCard';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {
  PAYMENT_METHODS_LIST
} from "../../../store/constants";
function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}
const filter = createFilterOptions({
  limit: 10
});
const AddPartyCompanyDetails = (props) => {
  let submit, formValues;
  const { 
    location, 
    user,
    trip, 
    vehicle, 
    sideBarOpen,
    sideBarClose, 
    sideBarTitle,
    parties,
    onSave,
    dispatchAddPartyCompanyDetails,
    dispatchUpdatePartyCompanyDetails
  } = props;
  const classes = useStyles();
  let history = useHistory();
  let fleetOwnerId = user.userInfo.entityId;
  let partyId = (location.state && location.state.partyId) ? location.state.partyId : "";
  const [open, setOpen] = React.useState(sideBarOpen);
  let companyDetails = parties.companyDetails?parties.companyDetails:{};
  const onConfirm = (confirm) => {
    setOpen(false);
    sideBarClose(false);
  }
  const onConfirmSave = (confirm) => {
    setOpen(false);
    onSave(false);
  }
  const goToTripView = (data) => {
    history.push({
      pathname: `/trips/view/${data.id}`,
      state: {
        id: 7,
        tripData: data,
        tripView: true,
        pageTitle: 'Trip Details',
        pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
      }
    });
  }
  useMountEffect(() => {
  
  });
  useEffect(() => {
    
  }, []);
  //state values
  const [gst, setGST] = React.useState(companyDetails && companyDetails.gst?companyDetails.gst:null);
  const [panNumber, setPANNumber] = React.useState(companyDetails && companyDetails.panNumber?companyDetails.panNumber:null);
  const [companyName, setCompanyName] = React.useState(companyDetails && companyDetails.name?companyDetails.name:null);
  const [addressLineOne, setAddressLineOne] = React.useState(companyDetails && companyDetails.addressLine1?companyDetails.addressLine1:null);
  const [addressLineTwo, setAddressLineTwo] = React.useState(companyDetails && companyDetails.addressLine2?companyDetails.addressLine2:null);
  const [state, setState] = React.useState(companyDetails && companyDetails.state?{State:companyDetails.state}:null);
  const [pincode, setPincode] = React.useState(companyDetails && companyDetails.pincode?companyDetails.pincode:null);


  //Form
  let initialValues = {
    gst:gst,
    panNumber:panNumber,
    companyName:companyName,
    addressLineOne:addressLineOne,
    addressLineTwo:addressLineTwo,
    state:state,
    pincode:pincode
  };
  const validate = values => {
    let gstValidation = new RegExp(user.configs.gstRegex);
    let panValidation = new RegExp(user.configs.panRegex);
    let pinCodeValidation = new RegExp(user.configs.pincodeRegex);
    let errors = {};
    if (!values.companyName) {
        errors.companyName = "Please enter the company name"
    }
    if (values.gst && (!gstValidation.test(values.gst))) {
        errors.gst = "GST number must be of length 15 characters and must contain only Numbers and Alphabets as per the Valid Format."
    }
    if (values.panNumber && (!panValidation.test(values.panNumber))) {
        errors.panNumber = "PAN number must be of length 10 characters and must contain only Numbers and Alphabets as per the Valid Format."
    }
    if (values.pincode && (!pinCodeValidation.test(values.pincode))) {
        errors.pincode = "Pin code must be of length 6 and must contain only Numbers."
    }
    return errors;
  };
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    let req = {
      "pincode": values.pincode,
      "name": values.companyName,
      "customerId": partyId,
      "gst": values.gst,
      "addressLine1":values.addressLineOne,
      "addressLine2":values.addressLineTwo,
      "panNumber": values.panNumber,
      "state":values && values.state && values.state.State?values.state.State:null
    }
    if (companyDetails.name) {
      dispatchUpdatePartyCompanyDetails(req,(response)=>{
        if(response && response.status && response.status && response.status.code && response.status.code=== 200){
          sendSucces("Party Details Added Successfully");
          onConfirmSave()
        }
      },()=>{
  
      })
    }else{
      dispatchAddPartyCompanyDetails(req,(response)=>{
        if(response && response.status && response.status && response.status.code && response.status.code=== 200){
          sendSucces("Party Details Added Successfully");
          onConfirmSave()
        }
      },()=>{
  
      })
    }
    
  };
  const getFormFields = (values) => {
    return [
        {
            size: 12,
            visible:true,
            field: (
              <TextField
                label={'GST Number'}
                placeholder="Enter a GST Number"
                name="gst"
                variant="outlined"
                size="small"
                margin="normal"
                onChange={(e)=>{
                  setGST(e.target.value);
                }}
                fieldProps={{
                }}
                InputProps={{
                  //startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                }}
                //required={true}
              />
            ),
        },
        {
          size: 12,
          visible:true,
          field: (
            <TextField
              label={'PAN'}
              placeholder="Enter a PAN"
              name="panNumber"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e)=>{
                setPANNumber(e.target.value)
              }}
              fieldProps={{
              }}
              InputProps={{}}
              //required={true}
            />
          ),
      },
      {
        size: 12,
        visible:true,
        field: (
          <TextField
            label={'Company Name'}
            placeholder="Enter a Company Name"
            name="companyName"
            variant="outlined"
            size="small"
            margin="normal"
            onChange={(e)=>{
              setCompanyName(e.target.value)
            }}
            fieldProps={{
            }}
            InputProps={{}}
            required={true}
          />
        ),
    },
    {
      size: 12,
      visible:true,
      field: (
        <TextField
          label={'Address Line 1'}
          placeholder="Enter a Address"
          name="addressLineOne"
          variant="outlined"
          size="small"
          margin="normal"
          multiline={true}
          onChange={(e)=>{
            setAddressLineOne(e.target.value)
          }}
          fieldProps={{
          }}
          InputProps={{}}
          //required={true}
        />
      ),
    },
    {
      size: 12,
      visible:true,
      field: (
        <TextField
          label={'Address Line 2'}
          placeholder="Enter a Address"
          name="addressLineTwo"
          variant="outlined"
          size="small"
          margin="normal"
          multiline={true}
          onChange={(e)=>{
            setAddressLineTwo(e.target.value)
          }}
          fieldProps={{
          }}
          InputProps={{}}
          //required={true}
        />
      ),
    },
    {
      size: 12,
      visible:true,
      field: (
          <Autocomplete
              classes={{
                  listbox: classes.listBoxAutoCompelete,
                  option: classes.listBoxOption
              }
              }
              id="select-state-name-list"
              name="state"
              size="small"
              value={state}
              placeholder="State"
              onChange={(event, newValue) => {
                setState(newValue)
              }}
              autoHighlight
              options={user.configs && user.configs.GST_STATE_LIST ? user.configs.GST_STATE_LIST : []}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              getOptionValue={option => option.State}
              getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  return option.State?option.State:'';
              }}
              disableCloseOnSelect={false}
              filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  return filtered;

              }}
              renderOption={(option, params) => {

                  return (
                      <div style={{ display: 'flex', width: '100%', paddingTop: 5, paddingBottom: 5 }}>
                          <LocationOnIcon style={{ color: 'lightgray' }} />
                          <div style={{width: '100%', paddingBottom: 10, paddingLeft: 5 }}>
                              {option.State}
                          </div>
                      </div>
                  );

              }}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      // label="Enter Reason"
                      placeholder="State"
                      variant="outlined"
                      name="state"
                      margin='normal'
                      style={{ margin: 0, marginTop: 6 }}
                  />
              )}
              multiple={false}
          />
      ),
  },
  {
    size: 12,
    visible:true,
    field: (
      <TextField
        label={'Pincode'}
        placeholder="Enter a Pincode"
        name="pincode"
        variant="outlined"
        type='number'
        size="small"
        margin="normal"
        onChange={(e)=>{
          setPincode(e.target.value)
        }}
        fieldProps={{
        }}
        InputProps={{}}
        //required={true}
      />
    ),
  }
  ]
  };
  return (
    <>
      {open && <RightSideBar
        sideBarTitle="add-edit-trip"
        rightSideBarOpen={open}
        sideBarTitle={companyDetails && companyDetails.panNumber?'Update Party Details':'Add Party Details'}
        sideBarType="form"
        validate={validate}
        handleSubmit={event => submit(event)}
        toggleRightSideBar={onConfirm} >
        <Form
          onSubmit={onSubmit}
          //keepDirtyOnReinitialize
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit, form, submitting, pristine, values }) => {
            submit = handleSubmit; formValues = values; return (
              <form onSubmit={handleSubmit} noValidate>
                <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                  {getFormFields(values).map((item, idx) => item.visible ? (
                    <Grid item xs={item.size} key={idx}>
                      {item.field}
                    </Grid>
                  ) : null)}
                </Grid>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </form>
            )
          }}
        />
      </RightSideBar>}
    </>
  );
}
AddPartyCompanyDetails.propTypes = {
  //tripId: PropTypes.any.isRequired,
};
const AddPartyCompanyDetailsWithRouter = withRouter(AddPartyCompanyDetails);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddPartyCompanyDetails: (data, onSuccess,onError) =>
    dispatch(addSinglePartyCompanyDetails(data,onSuccess,onError)),
  dispatchUpdatePartyCompanyDetails: (data, onSuccess,onError) =>
    dispatch(updateSinglePartyCompanyDetails(data,onSuccess,onError)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddPartyCompanyDetailsWithRouter);